module.exports = __webpack_public_path__ + "img/12.072d4f33.webp";